// файл для запросов

import { StaffSettingsObject } from "../../ComponentInterface";
import smetaAxios from "../../SmetaAxios";
import { XMLrequest } from "../../Url";
import { GetAmountDocTypes } from "../Sections/ElementsSections/BaseSumConsts";
import { RendHistoryParams } from "../Sections/ElementsSections/Staff/SectionStaffConsts";
import { ObjType } from "./Consts";
import { Prefixes } from "./ProjectX";
import { getModalSectionID } from "./Tools";

/////////////////////////////////////////////////////////////////////////////////
/////////////////////////Запросы для Справочника Организации/////////////////////
/////////////////////////////////////////////////////////////////////////////////

// запрос деталей(Табов)
export function GetTableLayout(
  module: string | Prefixes,
  objType: string | number,
  groupId: string | number,
  sectionId: string | number,
) {
  return smetaAxios.get("GetTableLayout", {
    prefix: module,
    params: { GroupID: groupId, ObjType: objType, SectionID: sectionId },
    loadMask: true,
  });
}

// запросы параметров Адрес и Дополнительно
export function handleParameters(
  module: string | Prefixes,
  value: any,
  selectedRecordID: string | number | undefined,
  objref: string | number,
) {
  return smetaAxios.get(value.Token, {
    prefix: module,
    params: {
      GroupId: selectedRecordID ? selectedRecordID : undefined,
      ObjRef: objref ? objref : undefined,
      NeedRefresh: value.Token === "HandleParams" ? "1" : undefined,
    },
    loadMask: true,
  });
}

export function GetAddressUseKladr() {
  return smetaAxios.get("GetAddressUseKladr", { prefix: Prefixes.address, loadMask: true }) as Promise<{
    service: string;
  }>;
}

// запрос для создания новых sources для основных таблицы
export function handleTable(data) {
  let groupID, subRequest;

  if (data.selectionMode) {
    if (data.GroupID.match(/[0-9]+/)) {
      groupID = data.GroupID.match(/[0-9]+/)[0];
      subRequest = { Groups: data.GroupID, MultiSel: "1" };
    } else {
      subRequest = { MultiSel: "1" };
    }
  } else groupID = data.GroupID;

  return function handleRequest(request) {
    return smetaAxios.post("HandleTable", subRequest ? { ...request, ...subRequest } : request, {
      prefix: data.Module,
      params: {
        ObjType: data.ObjType,
        SectionID: data.SectionID,
        GroupID: groupID,
        ID: data.selectedRecordID ? data.selectedRecordID : "0",
        OrgTypeCls: data.OrgTypeCls,
        Tag: data.Tag,
      },
      loadMask: true,
    });
  };
}

// запрос для создания новых columns для основной таблицы
export const PostHandleTable = (
  module: string | Prefixes,
  objType: string | number,
  groupId?: string | number,
  sectionId?: string | number,
  orgTypeCls?: string | number,
  path?: string,
) => {
  return smetaAxios.get("GetTableLayout", {
    prefix: module,
    params: {
      ObjType: objType,
      SectionID: sectionId ? sectionId : getModalSectionID(),
      GroupID: groupId,
      Path: path,
      OrgTypeCls: orgTypeCls,
    },
    loadMask: true,
  });
};

// запрос для создания новых columns для таблицы Счета
export function postHandleTableAccounts(
  module: string | Prefixes,
  objType: string | number,
  sectionId: string | number,
) {
  return smetaAxios.get("GetTableLayout", {
    prefix: module,
    params: { ObjType: objType, SectionID: sectionId },
    loadMask: true,
  });
}

// запрос для создания новых sources для таблицы Счета
export function handleTableAccounts(
  module: string | Prefixes,
  objType: string | number,
  groupID: string | number,
  sectionID: string | number,
) {
  return function handleAcc(request) {
    return smetaAxios.post(
      "HandleAccounts",
      { ...request, first: "0" },
      { prefix: module, params: { ObjType: objType, GroupID: groupID, SectionID: sectionID }, loadMask: true },
    );
  };
}

// Запрос для работы поиска
export function GetDialogParamsForSearch(module, ObjType, ObjRef) {
  const params = new Map();
  params.set("prefix", module).set("comand", "GetDialogParams").set("ObjType", ObjType).set("ObjRef", ObjRef);
  return XMLrequest(params);
}

export function GetDocDialogParams(objType: string | number, objRef: string | number, onlyView = false) {
  return smetaAxios.get("GetDialogParams", {
    prefix: Prefixes.doc,
    params: { ObjType: objType, ObjRef: objRef, OnlyView: onlyView ? "1" : undefined },
    loadMask: true,
  });
}

// Запрос для полей документов в справочнике организации
export function PostHandleTableDoc(module: string | Prefixes, docCfgID: string | number, sectionID: string | number) {
  return smetaAxios.get("GetDocumentLayout", {
    prefix: module,
    params: { DocCfgID: docCfgID, SectionID: sectionID, GridState: "1" },
    loadMask: true,
  });
}

// запрос для отрисовки записей таблицы документов
export function handleTableDoc(
  module: string | Prefixes,
  docCfgID: string | number,
  groupID: string | number,
  sectionID: string | number,
) {
  return (request) => {
    return smetaAxios.post("HandleDocument", request, {
      prefix: module,
      params: { DocCfgID: docCfgID, SectionID: sectionID, ParentID: groupID },
      loadMask: true,
    });
  };
}

// запрос для получения текстогого значения выбранной организации
export function getObjText(
  module: string | Prefixes,
  objType: string | number,
  objRef: string | number,
  flag: string | number,
) {
  return smetaAxios.get("GetObjectText", {
    prefix: module,
    params: { Flag: flag, ObjType: objType, ObjRef: objRef },
    loadMask: true,
  }) as Promise<{
    Text: string;
  }>;
}

export function setParamObjectText(
  module?: string | Prefixes,
  objType?: number | string,
  objRef?: number | string,
  value?: number | string,
  flag: number | string = "-1",
) {
  return smetaAxios.get(module ? "SetObjectText" : "SetParamObjectText", {
    prefix: module || Prefixes.progs,
    params: {
      Flag: module ? flag : undefined,
      ObjType: objType || "0",
      ObjRef: objRef || "0",
      Text: value === undefined ? "" : value,
    },
    loadMask: true,
  }) as Promise<{ ObjRef: string; Text: string; EditVal: string }>;
}

export function getParamObjectText(
  module?: string | Prefixes,
  objType?: number | string,
  objRef?: number | string,
  flag: number | string = "-1",
  editVal?: string,
) {
  return smetaAxios.get(module ? "GetObjectText" : "GetParamObjectText", {
    prefix: module || Prefixes.progs,
    params: {
      Flag: module ? flag : undefined,
      EditVal: module ? editVal : undefined,
      ObjType: objType || "0",
      ObjRef: objRef || "0",
    },
    loadMask: true,
  }) as Promise<{ Text: string; EditVal?: string }>;
}

// сохранение состояния справочника
export function saveBookState(module: string | Prefixes) {
  const params = new Map();
  params.set("prefix", module).set("comand", "SaveBookState");
  return XMLrequest(params);
}

export function treeRequest(module: string | Prefixes, objType: string | number, sectionId: string | number) {
  // organizations~GetGroupTree?LicGUID=0FC2363F4C23BD3E9E453A9ECFB19C7E&ObjType=2310&SectionID=494&Info=0&UsedDate=0&ObjRef=0
  return smetaAxios.get("GetGroupTree", {
    prefix: module,
    params: { ObjType: objType, SectionID: sectionId, Info: "0", UsedDate: "0", ObjRef: "0" },
    loadMask: true,
  });
}

export function getBookContextMenu(
  module: string | Prefixes,
  objType: string | number,
  objRef: string | number,
  sectionId?: string | number,
) {
  // GET /organizations~GetBookContextMenu?LicGUID=DFC8B0AC4CA6612D22434082622A9219&ObjRef=921&ObjType=2320&SectionID=100
  return smetaAxios.get("GetBookContextMenu", {
    prefix: module,
    params: { ObjType: objType, ObjRef: objRef, SectionID: sectionId },
    loadMask: true,
  }) as Promise<{
    Items: {
      items: Array<{
        Caption: string;
        Image?: string;
        ID?: string;
        ProgID?: string;
        Enabled?: string;
      }>;
    };
  }>;
}

export function getColumnParams(id: string | number, docID: string | number, docCfgID: string | number) {
  return smetaAxios.get("GetColumnParams", {
    prefix: Prefixes.doc,
    params: { ID: id, DocID: docID, DocCfgID: docCfgID },
    loadMask: true,
  });
}

/////////////////////////////////////////////////////////////////////////////////
/////////////////////////Запросы для Поиска//////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////

// запрос параметров для поиска
export function getSearchParams(groupId: string | number, module: string | Prefixes) {
  return smetaAxios.get("GetSearchParams", { prefix: module, params: { GroupID: groupId }, loadMask: true });
}

// запуск поиска
export function initSearch(module: string | Prefixes, path: string, index: string | number, objType: string | number) {
  return smetaAxios.get("InitSearch", {
    prefix: module,
    params: { Path: path, Index: index, ObjType: objType, smart: "1" },
    loadMask: true,
  }) as Promise<{
    Index?: string;
    Name?: string;
    ObjRef?: string;
    Result?: string;
  }>;
}

// остановка поиска
export function stopSearch(module: string | Prefixes) {
  return smetaAxios.get("StopSearch", { prefix: module, params: { smart: "1" }, loadMask: true }) as Promise<object>;
}

export function getParent(objRef: string | number) {
  const params = new Map();
  params
    .set("prefix", "persons")
    .set("comand", "GetObjectText")
    .set("Flag", "3")
    .set("ObjType", "2040")
    .set("ObjRef", objRef);
  const json = XMLrequest(params);
  return json;
}

export function setTreeGroup(
  module: string | Prefixes,
  objType: string | number,
  sectionId: string | number,
  parentId: string | number,
) {
  return smetaAxios.get("SetTreeGroup", {
    prefix: module,
    params: { DocCfgID: objType, SectionID: sectionId, ParentID: parentId },
    loadMask: true,
  }) as Promise<object>;
}

// GET /documents~GetColumnDetails?LicGUID=90E5DD5942BF9F359C3E61ADE768244A&DocCfgID=3011&ParentID=366452

export function GetColumnDetails(
  docCfgID: string | number,
  parentID: string | number,
  path: string | undefined,
  fieldName: string,
  module: string | Prefixes,
) {
  return smetaAxios.get("GetColumnDetails", {
    prefix: module ? module : Prefixes.doc,
    params: {
      Path: path ? path : undefined,
      FieldName: path ? fieldName : undefined,
      ID: path ? parentID : undefined,
      DocCfgID: !path && docCfgID ? docCfgID : undefined,
      ParentID: !path ? parentID : undefined,
    },
    loadMask: true,
  });
}

export function EditColumnField(data: {
  Module: string | Prefixes;
  DocCfgID: string | number;
  SectionID: string | number;
  ID: string | number;
  DocID?: string | number;
  MasterID?: string | number;
  Reference?: string | number;
}) {
  return smetaAxios.get("EditColumnField", {
    prefix: data.Module,
    params: {
      DocCfgID: data.DocCfgID,
      SectionID: data.SectionID,
      ID: data.ID,
      DocID: data.DocID ? data.DocID : "0",
      MasterID: data.MasterID ? data.MasterID : "0",
      Reference: data.Reference ? data.Reference : "0",
      WSM: "1",
    },
    loadMask: true,
  });
}

export function HandleSamples(data) {
  return smetaAxios.post("HandleSamples", data, {
    prefix: Prefixes.progs,
    params: { SectionID: data.SectionID ? data.SectionID : undefined },
    loadMask: true,
  });
}

export function ApplyFilter(data: {
  Filter?: string;
  Module: string | Prefixes;
  Parents?: string | number;
  SectionID?: string | number;
}) {
  return smetaAxios.post("ApplyFilter", data, {
    prefix: data.Module,
    params: {
      Filter: data.Filter !== undefined ? data.Filter : "",
      Parents: data.Parents ? data.Parents : "0",
      SectionID: data.SectionID ? data.SectionID : undefined,
    },
    loadMask: true,
  }) as Promise<{
    Result: string;
  }>;
}
// GET /documents~GetColumnHint?LicGUID=E64051504F01503EF9CED09D0AD7E63B&ID=3853&DocCfgID=3008&DocID=20694170
export function GetColumnHintDocs(data) {
  const params = new Map();
  params
    .set("prefix", "documents")
    .set("comand", "GetColumnHint")
    .set("ID", data.ID !== undefined ? data.ID : "0")
    .set("DocCfgID", data.DocCfgID)
    .set("DocID", data.DocID !== undefined ? data.DocID : "0")
    .set("MasterID", data.MasterID !== undefined ? data.MasterID : "0");
  const json = XMLrequest(params, data);
  return json;
}

export function SequenceGetParams(data: { Name: string; GetNumMode: string }) {
  return smetaAxios.get("SequenceGetParams", {
    prefix: Prefixes.seq,
    params: { Name: data.Name, GetNumMode: data.GetNumMode },
    loadMask: true,
  }) as Promise<{ AssignMode: string; Current: string; GetNumMode: string; Rights: string }>;
}

export function GetNextNumber(data: { Name: any; Range: any; MaxNumber: any }) {
  return smetaAxios.get("GetNextNumber", {
    prefix: Prefixes.seq,
    params: {
      Name: data.Name,
      Range: data.Range,
      MaxNumber: data.MaxNumber !== undefined && (data.Range === -4 || data.Range === 4) ? data.MaxNumber : undefined,
    },
    loadMask: true,
  }) as Promise<{
    Number: string;
  }>;
}

export async function GetSectionDocs(sectionId?: string | number) {
  if (!sectionId || sectionId <= 100) return "0";
  const json = (await smetaAxios.get("GetSectionDocs", {
    prefix: Prefixes.doc,
    params: { SectionID: sectionId, Simple: "1" },
    loadMask: true,
  })) as Array<{ DocCfgID: string; Name: string }>;
  return json.length ? json[0].DocCfgID : "0";
}

export const getStaffSettings = (sectionId: string | number) =>
  smetaAxios.get("GetStaffSettings", {
    prefix: Prefixes.staff,
    params: { SectionID: sectionId },
    loadMask: true,
  }) as Promise<StaffSettingsObject>;

export function ApplyTransFilter(sectionId: string | number) {
  return smetaAxios.get("ApplyTransFilter", {
    prefix: Prefixes.acc,
    params: { SectionID: sectionId },
    loadMask: true,
  }) as Promise<{
    Result: string;
    Status: string;
    Text: string;
  }>;
}

export function getAccsParams() {
  return smetaAxios.get("GetTransFilterParams", {
    prefix: Prefixes.acc,
    params: { GroupID: "0", NeedRefresh: "1" },
    loadMask: true,
  });
}

export function getRendHistoryParams(objRef: string | number) {
  return smetaAxios.get("GetRendHistoryParams", {
    prefix: Prefixes.staff,
    params: { ObjType: ObjType.RendHistory, ObjRef: objRef },
    loadMask: true,
  }) as Promise<RendHistoryParams>;
}

export function getPersonGroup(id: string | number) {
  return smetaAxios.get("GetPersonGroup", { prefix: Prefixes.person, params: { ID: id }, loadMask: true }) as Promise<{
    GroupID: string;
  }>;
}

export function getAmountDocTypes(renderingID?: string | number, payType?: string | number) {
  return smetaAxios.get("GetAmountDocTypes", {
    prefix: Prefixes.amount,
    params: { RenderingID: renderingID, PayType: payType },
    loadMask: true,
  }) as Promise<GetAmountDocTypes>;
}
